import styled from 'styled-components';

import { colors as internalColors } from '@crm-framework/theme';

import LogoXcriticalCrm from '../images/logo-xcritical-crm.png';

export const ContentWrapper = styled.div`
  width: 80%;
  margin: 10px auto;
  display: flex;
  min-width: 500px;
`;

export const NotificationButtonWrapper = styled.div`
  margin-left: auto;
`;

export const TokenWrapper = styled.div`
  height: 100vh;
  padding-top: 300px;
  background-color: ${internalColors.N1};
`;

export const FlexContainerCenter = styled.div`
  display: flex;
  justify-content: center;
`;

export const Logo = styled.div`
  display: block;
  height: 45px;
  margin: 0 auto 30px auto;
  background: url(${LogoXcriticalCrm}) no-repeat center;
`;
